<template>
    <div>
        <b-form-group
                :label-for="`id_${field._id}`"
                :class="{
                'required-field': !!field.isRequired,
            }"
        >
            <div class="row d-flex">
                <div class="col-md-10">
                    <h5>{{field.label}}</h5>
                </div>
                <div class="col-md-2">
                    <span class="addMoreIcon" title="Add More" @click="addMoreFields">+</span>
                </div>
            </div>

            <div class="form-border"></div>
            <!--<div class="row">-->
                <!--<div class="col-md-12">-->
                    <!--<span class="addMoreIcon" title="Add More" @click="addMoreFields">+</span>-->
                <!--</div>-->
            <!--</div>-->
                <div v-for="(additionalField, index) in additionalFields" :key="index" class="row position-relative">
                    <div v-for="(fieldOption, optionIndex) in field.multiOptions" :key="optionIndex"
                         :class="{
                            'col-md-12': Math.ceil(field.multiOptions.length) == 1,
                            'col-md-6': Math.ceil(field.multiOptions.length) == 2,
                            'col-md-4': Math.ceil(field.multiOptions.length) == 3,
                            'col-md-3': Math.ceil(field.multiOptions.length) == 4,
                            'col-md-2': Math.ceil(field.multiOptions.length) == 6,

                        }"
                    >
                        <b-form-group :label="fieldOption.label" :label-for="`id_${field._id}`"
                                      :class="{
                'required-field': !!field.isRequired,
            }">
                            <b-form-input
                                    v-model="additionalField[fieldOption.key]"
                                    type="text"
                                    v-validate="{
                    required: !!field.isRequired,
                    email: !!field.isEmail,
                    numeric: !!field.isNumeric,
                    regex: allExceptSpecialCharacters ,
                    max: field.maxLength ,
                    min: field.minLength,
                }"
                                    :placeholder="fieldOption.placeholder"
                                    :disabled="loading || isDisabled"
                                    :data-vv-name="fieldOption.label"
                                    @input="updateValue(field.key, fieldOption.key, index, $event)"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <span
                        v-if="additionalFields.length > 1"
                        class="removed-row-class"
                        @click.prevent="deleteRow(index,field.key)"
                        ><i class="icon-delete"></i
                    ></span>
                </div>

        </b-form-group>
    </div>
</template>




<script>
    import { mapGetters } from 'vuex'
    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > inject
        |--------------------------------------------------------------------------
        */
        inject: {
            $validator: '$validator',
        }, // End of Component > inject

        /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
        components: {}, // End of Component > components

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            field: {
                type: Object,
                required: true,
            },
        }, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                value: '',
                isDisabled: false,
                country:process.env.VUE_APP_COUNTRY,
                allExceptSpecialCharacters: /^[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/,
                dynamicInputValues: {},
                additionalFields: [],
            }
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        //    contactInfo.city
        created() {

            const additionalField = {};
            let valueFound=false
            let isEdit = false
            let existingVal = ''
            let existingFields=this.$store.getters.form.dynamicInputValues
            if((existingFields && existingFields[this.field.key]))
            {
                existingVal=this.$store.getters.form.dynamicInputValues[this.field.key]
                if(existingVal.length>0)
                {
                    valueFound=true
                }
            }
            else if(this.field.customerDetails && this.field.customerDetails.dynamicInputValues && this.field.customerDetails.dynamicInputValues[this.field.key])
            {
                 existingVal=this.field.customerDetails.dynamicInputValues[this.field.key]
                if(existingVal.length>0)
                {
                    valueFound=true
                    isEdit=true
                }
            }

            // console.log('this field',this.field,existingFields,existingFields[this.field.key])


            if(valueFound)
            {
                for(let i=0;i<existingVal.length;i++)
                {
                    this.field.multiOptions.forEach((fieldOption) => {
                        let val= ""

                        if(existingVal[i][fieldOption.key])
                        {
                            val=existingVal[i][fieldOption.key]

                        }
                        additionalField[fieldOption.key] = val;

                        if(isEdit)
                        {
                            this.updateValue(this.field.key,fieldOption.key,i,val)
                        }

                    });
                    this.additionalFields.push({...additionalField});
                }
            }
            else
            {
                this.field.multiOptions.forEach((fieldOption) => {
                    additionalField[fieldOption.key] = '';
                });
                this.additionalFields.push(additionalField);
            }

        }, // End of Component > methods
        computed: {
            ...mapGetters(['loading']),
        }, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        mounted() {
        }, // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {

            addMoreFields() {
                const additionalField = {};
                this.field.multiOptions.forEach((fieldOption) => {
                    additionalField[fieldOption.key] = '';
                });
                this.additionalFields.push(additionalField);
            },
            updateValue(parentKey, key, index, event) {
                if (!this.dynamicInputValues[parentKey]) {
                    this.dynamicInputValues[parentKey] = [];
                }
                // Update the array at the specified index with the new object
                const fieldValue = { [key]: event };
                if (this.dynamicInputValues[parentKey].length <= index) {
                    this.dynamicInputValues[parentKey].push(fieldValue);
                } else
                    {
                    this.dynamicInputValues[parentKey][index] = {
                        ...this.dynamicInputValues[parentKey][index],
                        ...fieldValue,
                    };
                }

                let value = this.dynamicInputValues[parentKey][index]
                this.$store.commit('setDynamicInputValue', { parentKey,key, index,value });

            },
            getDynamicFieldName(parentKey, childKey) {
                let customInfo = this.$store.getters.getField(`dynamicInputValues.${parentKey}.${childKey}`)
                return customInfo;
            },
            deleteRow(index,parentKey) {
                this.additionalFields.splice(index, 1)
                this.dynamicInputValues[parentKey].splice(index,1)
                this.dynamicInputValues[parentKey] = this.dynamicInputValues[parentKey].filter(function(){return true;});
                this.$store.commit('updateField', {
                    key: `dynamicInputValues.${parentKey}`,
                    value: this.dynamicInputValues[parentKey],
                })
            },

        }, // End of Component > mounted
    }
</script>
<style>
    .divider
    {
        border-bottom: 1px solid grey;
        width: 100%;
        margin-bottom: 2%;
    }
    .addMoreIcon
    {
        background: var(--primary-color);
        color: white;
        padding-right: 7px;
        padding-left: 7px;
        cursor: pointer;
        float: right;
    }
</style>
